module.exports = __webpack_public_path__ + "img/Lincover.d02c34e1.jpg";